import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import { hasIvtEditorAccess } from '../../utils/authorization';

/**
 * Role-based landing for `/ivt/` (no sub-path), per DAT-9259 item 5:
 *   - editors and admins land on the Dashboard (DashboardPage itself picks GM vs STO from
 *     `hasIvtAdminAccess`),
 *   - plain `ivthub` viewers (BD and the like) land on the existing Solution Map page.
 *
 * Deep links like `/ivt/dashboard` / `/ivt/solution-map` keep working — this replaces only
 * what the `/ivt/` INDEX used to render. `replace` so Back from the dashboard goes to where
 * the user came from, not through an empty redirect step.
 *
 * Lives in its own module so a test can import it without pulling in App.tsx's whole surface
 * (CopilotKit CSS, Cognito, etc.) and so the file co-locates with the other `/ivt/components/*`
 * layout concerns.
 */
export function IvtLanding() {
  const { ldap_groups } = useAuth();
  return (
    <Navigate
      to={hasIvtEditorAccess(ldap_groups) ? '/ivt/dashboard' : '/ivt/solution-map'}
      replace
    />
  );
}

export default IvtLanding;
